import { render, staticRenderFns } from "./visit.vue?vue&type=template&id=24f1a105&scoped=true"
import script from "./visit.vue?vue&type=script&lang=js"
export * from "./visit.vue?vue&type=script&lang=js"
import style0 from "./visit.vue?vue&type=style&index=0&id=24f1a105&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f1a105",
  null
  
)

export default component.exports